import { AxiosResponse } from 'axios';
import { IRelatedStoryMapper, IApiResult } from '../types';
import settings from '../settings';
import api from './base';

export function getRelatedStories(storyId: number): Promise<AxiosResponse<IRelatedStoryMapper[]>> {
  return api.http.get(`${settings.getApiURI()}/story-admin/v2/stories/${storyId}/related-stories`);
}

export function createRelatedStory(storyId: number, payload: any): Promise<AxiosResponse<IApiResult<IRelatedStoryMapper>>> {
  return api.http.post(`${settings.getApiURI()}/story-admin/v2/stories/${storyId}/related-stories`, payload);
}

export function updateRelatedStory(mapperId: number, payload: any): Promise<AxiosResponse<IApiResult<IRelatedStoryMapper>>> {
  return api.http.put(`${settings.getApiURI()}/story-admin/v2/related-stories/${mapperId}`, payload);
}

export function deleteRelatedStory(mapperId: number): Promise<AxiosResponse<IApiResult<IRelatedStoryMapper>>> {
  return api.http.delete(`${settings.getApiURI()}/story-admin/v2/related-stories/${mapperId}`);
}
